export const Routes = {
  API_HOSTNAME: process.env.REACT_APP_API_HOSTNAME,
  LEADFORMPUBLICURL: process.env.REACT_APP_LEADFORMPUBLICURL,

  LOGIN: "admin-login",
  UPDATESETTING: "setsettings",
  UPDATEINVOICESTART: "updateinvoicestart",
  INSERTLVBDATA: "insertlvbdata",
  UPDATEDESCRIPTIONSETTING: "setdescriptionsettings",
  GETESETTING: "getsettings",
  GETCONTENTHISTORY: "getcontenthistory",
  GETCHAPTER: "getchepterbyid",
  GETALLCHAPTER: "getchapter",
  UPDATECHAPTER: "update-chepter",
  INSERTMEMBER: "insert-member",
  INSERTSTATE: "insert-state",
  GETSTATE: "getall-state",
  GETCITY: "getcity",
  GETALLUSER: "getuser",
  INSERTCHAPTER: "insert-chapter",
  GETALLMEMBER: "getallmemberweb",
  GETPRIVILEGEACTIVEMEMBERLIST: "getprivilegeactivememberlist",
  // GETMEMBERBYID: "getmember",
  GETMEMBERBYID: "getmemberbyid",
  UPDATEMEMBER: "update-member",
  MEMBERIMAGEURL: "/images/member",
  GETPOLLSELECT: "getpolloption",
  INSERTPOLL: "insert-poll",
  INSERTEVENT: "insert-event",
  INSERTGALLERY: "insert-gallery",
  GETALLGALLERY: "getallgallery",
  DELETEGALLERY: "deletegallery",
  GETALLPOLL: "getallpoll",
  DELETEPOLL: "deletepoll",
  UPDATEPOLL: "update-poll",
  GETALLEVENTANNO: "getalleventannoucement",
  EVENTANNOUDELETE: "deleteeventannoucement",
  UPDATEMEMBERSTATUS: "update-member-status",
  USERLOGOUT: "logout",
  GETMEMBERBYCHPT: "getmemberbychptweb",
  UPDATEMEMBERPOST: "update-position",
  GETPOLLRESULT: "getpollresult",
  GETALLCITY: "getallcityweb",
  GETALLSTATE: "getall-state",
  GETALLCOUNTRY: "getcountry",
  INSERTCITY: "insert-city",
  INSERTCOUNTRY: "insert-country",
  GETMEETING: "getmeeting",
  INSERTLANDMARK: "insert-landmark",
  INSERTMEETING: "insert-meeting",
  GETALLLANDMARK: "getalllandmark",
  GETSETTINGHISTORY: "getsettinghistory",
  GETLVBDATA: "getlvbdata",
  UPDATELANDMARKSTATUS: "update-landmarkstatus",
  UPDATESTATESTATUS: "update-statestatus",
  UPDATECITYSTATUS: "update-citystatus",
  GETMEETINGBYID: "getmeetingbyid",
  UPDATEMEETING: "update-meeting-web",
  // Get Business And Edit , Delete
  GETALLBUSINESS: "getbusinessbymember",
  GETALLBUSINESSV1: "getbusinessv1",
  UPDATEBAMOUNT: "update-bamount-web",
  DELETEBUSINESS: "deletebusiness",
  GETV2VLIST: "getv2vbymember",
  GETV2VLISTV1: "getv2vv1",
  GETVISITORBYID: "getvisitorbymember",
  GETVISITORV1: "getvisitorv1",
  DELETEVISITOR: "deletevisitor",
  DELETEV2V: "deletev2v",
  GETREFERENCELIST: "getreferencebymember",
  GETREFERENCELISTV1: "getreferencev1",
  DELETEREFERENCE: "deletereference",
  DELETECHAPTER: "deletechapter",
  RESETMEETINGMEMBER: "resetmeetingmember",
  GETTESTIMONIALLIST: "gettestimonialweb",
  GETTESTIMONIALLISTV1: "gettestimonialwebv1",
  DELETETESTIMONIAL: "deletetestimonial",
  // Get State
  GETSTATEBYID: "getstatebyid",
  UPDATESTATE: "updatestate",
  // UPdate City
  UPDATECITY: "updatecity",
  UPDATELANDMARK: "updatelandmarkweb",
  DELETEMEETING: "deletemeeting",
  GETATTENDANCE: "getattendance",
  UPDATEEVENTANNOUNCEMENT: "update-event",
  GETMEMBERATTENDANCEBYCHEPER: "memberattendancebychepter",
  GETMEMBERATTENDANCEBYID: "memberattendancebyid",
  INSERTGREETING: "insert-greeting",
  GETALLGREETING: "getallgreeting",
  GREETINGDELETE: "deletegreeting",
  RESENDGREETING: "resendgreeting",
  GETCHAPTERBYCITY: "getchapterbycityid",
  INSERTCITYAMBASSODAR: "insertcityambassador",
  GETCITYAMBASSADORBYID: "getcityambassadorbyid",
  GETACTIVEMEMBERBYCHPT: "getactivememberbychptweb",
  UPDATECITYAMBSSADORDEATILS: "updatecityambassodardeatils",
  INSERTSTAFF: "insertstaff",
  GETSTAFFBYPID: "getstaffbypid",
  UPDATESTAFFSTATUS: "updatestaffstatus",
  DELETESTAFF: "deletestaff",
  UPDATESTAFFDETAILS: "updatestaffdetails",
  GETALLOCATELISTBYID: "getallocatelistbyid",
  INSERTLEAD: "insertlead",
  INSERTTASK: "inserttask",
  GETTASKLIST: "gettaskbyid",
  GETLEADLIST: "getleadbyid",
  UPDATETASKSTATUS: "updatetaskstatus",
  UPDATELEADSTATUS: "updateleadstatus",
  UPDATELEADEXPIRY: "updateleadexpirydate",
  GETTASKBYTID: "gettaskbytid",
  UPDATETASKDETAILS: "updatetaskdetails",
  DELETETASK: "deletetask",
  UPDATETASKPRIORITY: "updatetaskpriority",
  GETLEADBYLID: "getleadbylid",
  UPDATELEADDETAILS: "updateleaddetails",
  INSERTFOLLOWUP: "insertfollowup",
  GETLEADHISTORY: "getleadhistory",
  LEADTRANSFERTO: "transferlead",
  UPLOADPAYMENTIMAGE: "uploadpaymentimage",
  GETCHAPTERBYUSER: "getchapterbyuser",
  GETMEETINGBYUSER: "getmeetingbyuser",
  GETMEETINGBYUSERV2: "getmeetingbyuser",
  INSERTNEWCITYAMBASSADOR: "insertnewcityambassador",
  GETALLCITYAMABASSADOR: "getallcityambassador",
  DELETECITYAMBASSADOR: "deletecityambassador",
  PAYMENTWITHDRAWAL: "paymentwithdrawal",
  GETRENEWALMEMBERDATA: "getrenewalmemberdata",
  MEMBERRENEWAL: "memberrenewal",
  CHANGECITYAMBASSADOR: "changecityambassador",
  GETDASHBOARDCOUNTER: "getdashboardcounter",
  GETDASHBOARDPINCOUNTER: "getdashboardpincounter",
  GETWALLETHISTORYBYID: "getwallethistorybyid",
  GETMEMBERFEEHISTORY: "getmemberfeehistory",
  GETMEMBERPROFILEWEB: "getmemberprofileweb",
  GETMEMBERINDUCTIONDATA: "getmemberinductiondata",
  UPLOADLVBDOCUMENT: "uploadlvbdocument",
  GETLVBDOCUMENT: "getlvbdocument",
  DELETEDOCUEMENT: "deletedocuement",
  UPDATECITYAMBASSADORPROFILE: "updatecityambassadorprofile",
  INSERTFOLDER: "insertfolder",
  DELETEPAYMENTMETHOD: "deletepaymentmethod",
  INSERTPAYMENTMETHOD: "insertpaymentmethod",
  GETPAYMENTMETHOD: "getpaymentmethod",
  UPDATEPAYMENTMETHOD: "updatepaymentmethod",
  GETFOLDERBYCITYID: "getfolderbycityid",
  GETDOCUMENTBYFID: "getdocumentbyfid",
  DELETESUBFOLDER: "deletesubfolder",
  V2VREPORTBYMEMBER: "getv2vmemberreport",
  BUSINESSREPORTBYMEMBER: "getbusinessbymemberreport",
  GETREFERENCEREPORTBYMEMBER: "getreferencebymemberreport",
  GETVISITORREPORTBYMEMBER: "getvisitorbymemberreport",
  GETATTENDANCEREPORT: "getattendancebymemberreport",
  GETLVBCOUNTERWEB: "getlvbcounterweb",
  GETLVBSEARCHCOUNTER: "getlvbsearchcounter",
  GETCITYSEARCHCOUNTER: "getcitysearchcounter",
  GETCITYCHAPTERSEARCHCOUNTER: "getcitychaptersearchcounter",
  GETCITYAMBDETAILBYID: "getcityambdetailbyid",
  FINDTOPPER: "find-topper",
  CHAPTERSMEMBERDATA: "chapters-member-data",
  INSERTPINBADGE: "insert-pin-badge",
  GETPINLIST: "get-pin-list",
  GETPINREPORTBYMEMBER: "getpinreportbymember",
  UPDATEPIN: "update-pin",
  ASSIGNPIN: "assign-pin",
  GETPINBYMEMBERID: "get-pin-by-member-id",
  UPDATEMEMBERVERIFYSTATUS: "update-member-verify-status", //
  GETMEMBERSDETAILREPORT: "get-members-detail-report",
  GETMEMBERSPECIFICDETAILREPORT: "get-member-specific-detail-report",
  INSERTBLACKLISTVISITOR: "add-visitor-blocklist",
  GETBLOCKVISITORLIST: "get-block-visitor-list",
  GETLEADDETAILBYID: "get-leaddetails-by-id",
  UPDATELVBLEAD: "update-lvb-lead",
  GETSUGGESTIONLIST: "get-suggestion-list",
  UPLOADSUGGESTIONCHUNK: "uploadsuggestionchunk",
  UPDATEPUBLICLEADFORMEDITMODE: "update-public-lead-form-edit-mode",
  GETMEMBERINDUCTIONLIST: "get-member-induction-list",
  INSERTPUBLICLEADFORM: "insert-public-lead",
  EXPORTMEMBERALLSPECIFICDATA: "export-member-all-specific-data",
  EXPORTMEMBERALLZIP: "export-member-all-zip",
  THANKYOUNOTEWAITINGLIST: "thankyounote-waiting-list",
  APPROVETHANKYOUNOTE: "approve-thankyounote",
  DELETEUNAPPROVEDTHANKYOUNOTE: "delete-waiting-thankyounote",
  GETNEWLEADLIST: "getleadbyid-v2",
  GETNEWLEADFOREXPORT: "get-new-lead-for-export",
  PINASSIGNREPORT: "pin-assign-report",
  EXPORTCITYCHAPTERREPORT: "export-city-chapter-report",
  DELETEVISITORBLOCKLIST: "delete-visitor-blocklist",
  GETVISITORPREVIOUSELIST: "get-visitor-previous-list",
  CHECKMOBILEVALIDATION: "check-mobile-validation",
  CHAPTERREACTIVE: "chapter-reactive",
  CHAPTERLOGHISTORY: "chapter-log-history",
  UPDATEPASSWORD: "update-password",
  CHANGEUSERPASSWORD: "changeuserpassword",
  INSERTMEMBERSHIPFLOW: "insert-membership-flow",
  UPDATEMEMBERSHIPFLOW: "update-membership-flow",
  MEMBERSHIPFLOWIMAGEDELETE: "deletemembershipflowimage",
  GETMEMBERSHIPFLOWLIST: "get-membershipflow-list",
  INSERTMAGAZINE: "insert-magazine",
  GETMAGAZINELIST: "getmagazinelist",
  MAGAZINEDELETE: "deletemagazine",
  UPDATEMAGAZINE: "update-magazine",
  INSERTNOTIFICATION: "insert-notification",
  BATCHINSERTNOTIFICATION: "insert-notification",
  UPDATENOTIFICATION: "update-notification",
  DELETENOTIFICATION: "deletenotification",
  GETALLNOTIFICATION: "getallnotification",
  GETREADNOTIFICATIONDATA: "getreadnotificationdata",
  GETNOTIFICATIONBYBATCH: "get-notification-by-batch",
  GETNOTIFICATIONCHILDREN: "get-notification-children",
  BATCHINSERTPOLL: "insert-poll",
  GETPOLLBYBATCH: "get-poll-by-batch",
  GETPOLLCHILDREN: "get-poll-children",
  INSERTTRAININGWEBINAR: "insert-training-webinar",
  UPDATETRAININGWEBINAR: "update-training-webinar",
  DELETETRAININGWEBINAR: "deletetrainingwebinar",
  GETALLTRAININGWEBINAR: "getalltrainingwebinar",
  INSERTACHIEVEMENTPINBADGE: "insert-achievement-pin-badge",
  INSERTLVBRECORDS: "insertlvbrecords",
  UPDATELVBRECORDS: "updatelvbrecords",
  GETLVBRECORDS: "getlvbrecords",
  GETACHIEVEMENTPINLIST: "get-achievement-pin-list",
  GETACHIEVEMENTPINSWITHPROGRESS: "getallachievementpinswithprogress",
  UPDATEACHIEVEMENTPINBADGE: "update-achievement-pin-badge",
  INSERTMEETINGFEEDBACKFOR: "insertmeetingfeedbackfor",
  UPDATEMEETINGFEEDBACKFOR: "updatemeetingfeedbackfor",
  DELETEMEETINGFEEDBACKFOR: "deletemeetingfeedbackfor",
  GETMEETINGFEEDBACKFOR: "getmeetingfeedbackfor",
  GETMEETINGBYCHPTID: "getmeetingbychapter",
  GETMEETINGFEEDBACKREPORT: "meeeting-feedback-report",
  GETMEMBERFEEDBACKATTACHMENT: "getmemberfeedbackattachment",
  GETMEMBERV2VSHEETREPORTDATA: "getmemberv2vsheetreportdata",
  GETMEMBERV2VSHEETDATA: "getmemberv2vsheetdata",
  DOWNLOADV2VSHEET: "downloadv2vsheet",
  INSERTASKREJECTREASON: "insertaskrejectreason",
  UPDATEASKREJECTREASON: "updateaskrejectreason",
  DELETEASKREJECTREASON: "deleteaskrejectreason",
  GETASKREJECTREASON: "getaskrejectreason",
  GETASKSLIST: "getaskslist",
  ASKAPPROVEREJECT: "askapprovereject",
  UPDATESUGGESTIONANSWER: "updatesuggestionanswer",
  DELETESUGGESTIONATTACHMENT: "deletesuggestionattachment",
  INSERTV2VREJECTREASON: "insertv2vrejectreason",
  UPDATEV2VREJECTREASON: "updatev2vrejectreason",
  DELETEV2VREJECTREASON: "deletev2vrejectreason",
  GETV2VREJECTREASON: "getv2vrejectreason",
  GETV2VDATALIST: "getv2vdatalist",
  V2VAPPROVEREJECT: "v2vapprovereject",
  INSERTBLUETICKREJECTREASON: "insertbluetickrejectreason",
  UPDATEBLUETICKREJECTREASON: "updatebluetickrejectreason",
  DELETEBLUETICKREJECTREASON: "deletebluetickrejectreason",
  GETBLUETICKREJECTREASON: "getbluetickrejectreason",
  GETBLUETICKAPPLYLIST: "getbluetickapplylist",
  BLUETICKAPPROVEREJECT: "bluetickapprovereject",
  INSERTMGT: "insert-mgt",
  UPDATEMGT: "update-mgt",
  DELETETMGT: "deletetmgt",
  GETALLMGTLIST: "getallmgtlist",
  INSERTMGTQUESTIONS: "insertmgtquestions",
  UPDATEMGTQUESTIONS: "updatemgtquestions",
  DELETEMGTQUESTIONS: "deletemgtquestions",
  GETMGTQUESTIONS: "getmgtquestions",
  GETBLUETICKQUESTIONANSWER: "getbluetickquestionanswer",
  INSERTMEMBERLEADREJECTREASON: "insertmemberleadrejectreason",
  GETFOLLOWUPLEADLIST: "getfollowuplead",
  INSERTLEADREJECTREASON: "insertleadrejectreason",
  UPDATELEADREJECTREASON: "updateleadrejectreason",
  DELETELEADREJECTREASON: "deleteleadrejectreason",
  GETLEADREJECTREASON: "getleadrejectreason",
  INSERTOBTREJECTREASON: "insertobtrejectreason",
  UPDATEOBTREJECTREASON: "updateobtrejectreason",
  DELETEOBTREJECTREASON: "deleteobtrejectreason",
  GETOBTREJECTREASON: "getobtrejectreason",
  INSERTOBTQUESTIONS: "insertobtquestions",
  UPDATEOBTQUESTIONS: "updateobtquestions",
  DELETEOBTQUESTIONS: "deleteobtquestions",
  GETOBTQUESTIONS: "getobtquestions",
  INSERTOBT: "insert-obt",
  UPDATEOBT: "update-obt",
  DELETEOBT: "deletetobt",
  GETALLOBTLIST: "getallobtlist",
  GETOBTAPPLYLIST: "getobtapplylist",
  GETOBTQUESTIONANSWER: "getobtquestionanswer",
  OBTAPPROVEREJECT: "obtapprovereject",
  INSERTMEMBERDEACTIVEREASON: "insertmemberdeactivereason",
  UPDATEMEMBERDEACTIVEREASON: "updatememberdeactivereason",
  DELETEMEMBERDEACTIVEREASON: "deletememberdeactivereason",
  GETMEMBERDEACTIVEREASON: "getmemberdeactivereason",
  SENDOTPTOMOBILE: "sendotptomobile",
  CHECKMOBILENUMBEREXIST: "checkmobilenumberexist",
  UPDATEEDITMODEINMEMBERRENEWALLEAD: "update-editmode-in-member-renewal-lead",
  GETMEMBERCONNECTEDANDBLOCKLIST: "get-member-connected-and-block-list",
  UPDATECONNECTIONREQUESTMAILSTATUS: "updateconnectionrequestmailstatus",
  ADDUPDATEPAGEINSTRUCTION: "addupdatepageinstruction",
  ADDUPDATEAPPLICATIONROUTE: "addupdateapplicationroute",
  GETPAGEINSTRUCTION: "getpageinstruction",
  GETAPPLICATIONROUTE: "getapplicationroute",
  ADDMEMBERTOBLOCK: "add-member-to-block",
  GETBLOCKMEMBERLIST: "get-block-member-list",
  REMOVEMEMBERFROMBLOCK: "remove-member-from-block",
  VERIFYGSTNUMBER: "verify-gst-number",
  READMEMBERFEEDBACK: "readmemberfeedback",
  GETMEMBERHISTORY: "getmemberhistory",
  DELETELEADATTACHMENT: "deleteleadattachment",
  INSERTCUSTOMER: "insertcustomer",
  UPDATECUSTOMER: "updatecustomer",
  GETCUSTOMERS: "getcustomers",
  DELETECUSTOMER: "deletecustomer",
  ADDPRODUCTITEM: "addproductitem",
  GETPRODUCTITEM: "getproductitem",
  UPDATEPRODUCTITEM: "updateproductitem",
  DELETEPRODUCTITEM: "deleteproductitem",
  // Stock Management

  GETSTOCKPRODUCTLIST: "getstockproductlist",
  INSERTPRODUCT: "insertproduct",
  GETPRODUCT: "getproduct",
  UPDATEPRODUCT: "updateproduct",
  UPDATEPRODUCTSTATUS: "updateproductstatus",
  STOCKOUTSENDTYPE: "stockoutsendtype",
  INSERTSTOCKINDATA: "insertstockindata",
  ASSIGNSTOCKTOCITY: "assignstocktocity",
  GETSTOCKHISTORY: "getstockhistory",
  GETWELCOMEKITMEMBERLIST: "getwelcomekitmemberlist",
  GETPINMEMBERLIST: "getpinmemberlist",
  ASSIGNPRODUCTTOMEMBER: "assignproducttomember",
  UPDATESTOCKSTATUS: "updatestockstatus",
  RETURNPRODUCTTOLVB: "returnproducttolvb",
  REASSIGNPRODUCTTOMEMBER: "reassignproducttomember",
  GETCITYWISEWALLETLIST: "getcitywisewalletlist",
  CAPTURECITYSTOCKAMOUNT: "capturecitystockamount",
  GETWALLETHISTORY: "getwallethistory",
  GETMEMBERALLASSIGNDATA: "getmemberallassigndata",
  INSERTSTOCKRETURNENTRY: "insertstockreturnentry",
  UPDATESTOCKRETURNSTATUS: "updatestockreturnstatus",
  UPDATESTOCKINDATA: "updatestockindata",
  PAYSTOCKAMOUNT: "paystockamount",
  GETPENDINGPAYOUTENTRIES: "getpendingpayoutentries",
  INSERTTRAVELLINGTYPE: "insert-travelling-type",
  GETTRAVELLINGTYPELIST: "get-travelling-type-list",
  UPDATETRAVELLINGTYPE: "update-travelling-type",
  GETALLMEMBERTRAVELLINGLIST: "getallmembertravellinglist",
  DISABLEMEMBERELIGIBILITY: "disablemembereligibility",
  GETPENDINGMEETINGVISITOR: "getpendingmeetingvisitor",
  GETSTOCKREPORTCITY: "getstockreportcitylist",
  GETPENDINGSTOCKOVERVIEW: "getpendingstockoverview",
  GETPENDINGSTOCKFILTERS: "getpendingstockfilteroptions",
  VALIDATECITYFORMLINK: "validatecityformlink",

  GETATTRIBUTE: "getattribute",
  UPDATEATTRIBUTE: "updateattribute",

  // Invoice
  CREATEINVOICE: "createinvoice",
  UPDATEINVOICE: "updateinvoice",
  GETINVOICELIST: "getinvoicelist",
  VALIDATEINVOICELINK: "validateinvoicelink",
  GETCITYPACKAGEAMOUNT: "getcitypackageamount",
  GENERATEMEMBERINVOICE: "generatememberinvoice",
  GENERATEMEMBERINVOICEFROMADMIN: "generatememberinvoicefromadmin",
  SENDINVOICEOTPTOMOBILE: "sendinvoiceotptomobile",
  GETMEMBERINVOICEDETAILS: "getmemberinvoicedetails",
  GETCUSTOMERLISTFORINVOICE: "getcustomerlistforinvoice",
  FETCHGSTDETAILSBYNUMBER: "fetchgstdetailsbynumber",
  SENDINVOICEREMINDERTOMEMBER: "sendinvoiceremindertomember",
  GETINVOICELISTZIP: "getinvoicelistzip",
  UPDATEINVOICEDETAILS: "updateinvoicedetails",
  GETSTATELIST: "getstatelist",
  GETCITYLISTBYSTATE: "getcitylistbystate",
  UPDATEINVOICESTATUS: "updateinvoicestatus",

  // Unassigned Chapter & Coordinator Vacancy
  GETCHAPTERLISTWITHCOORDINATORS: "getchapterlistwithcoordinators",

  GETSYSTEMLOGMODULES: "get-system-log-modules",
  GETSYSTEMLOGS: "get-system-logs",

  GETCITYSUPPORTLIST: "getcitysupportlist",
  CREATECITYSUPPORTPROFILE: "createcitysupportprofile",
  UPDATECITYSUPPORTPROFILE: "updatecitysupportprofile",
  DELETECITYSUPPORTPROFILE: "deletecitysupportprofile",
  UPDATECITYSUPPORTPROFILESTATUS: "updatecitysupportprofilestatus",

  GETCITYEDDETAILS: "getcityeddetails",
  SAVECITYEDDETAILS: "savecityeddetails",

  GETRENEWALFOLLOWUPREPORT: "getrenewalfollowupreport",
  // Coordinator & Role Management
  GETPOSTTYPES: "getposttypes",
  CREATEROLE: "createrole",
  UPDATEROLE: "updaterole",
  GETROLES: "getroles",
  GETROLEDETAIL: "getroledetail",
  TOGGLEROLESTATUS: "togglerolestatus",
  GETCHAPTERCOORDINATORS: "getchaptercoordinators",
  GETCHAPTERPOSTSTRUCTURE: "getchapterpoststructure",
  GETCHAPTERMEMBERS: "getchaptermembers",
  GETSELFROLEELIGIBLEMEMBERS: "getselfroleeligiblemembers",
  ASSIGNCOORDINATOR: "assigncoordinator",
  REMOVECOORDINATOR: "removecoordinator",
  CHANGECOORDINATOR: "changecoordinator",
  GETROLERESPONSHISTORY: "getroleresponsibilitieshistory"
};
